var e = {
	title: "About this guest",
	open: "Guest intel",
	stays: {
		returning: "Returning guest",
		firstTime: "First stay with you",
		completed_one: "{{count}} completed stay",
		completed_other: "{{count}} completed stays",
		noShows_one: "{{count}} no-show",
		noShows_other: "{{count}} no-shows",
		cancelled_one: "{{count}} cancelled booking",
		cancelled_other: "{{count}} cancelled bookings",
		lastStay: "Last stayed at {{listing}}, checked out {{date}}",
		firstStay: "First stayed with you on {{date}}"
	},
	stats: {
		completed: "Stays",
		noShows: "No-shows",
		cancelled: "Cancelled"
	},
	reviews: {
		title: "Reviews they left you",
		none: "No reviews from this guest yet",
		average_one: "{{rating}} average from {{count}} review",
		average_other: "{{rating}} average from {{count}} reviews",
		latest: "Latest review, {{date}}"
	},
	notes: {
		title: "Team notes",
		empty: "No notes on this booking yet. Notes are visible to your team only.",
		placeholder: "Add a note for your team",
		add: "Add note",
		tooLong: "Keep a note to {{max}} characters",
		delete: "Delete note",
		deleted: "Note deleted",
		byYou: "You",
		bySomeone: "A team member",
		byline: "{{author}} · {{time}}",
		confirmDelete: "Delete this note? Your team will no longer see it.",
		failed: "That didn't go through. Try again."
	},
	refusal: { NOTE_NOT_YOURS: "Only the person who wrote this note can delete it." },
	identity: { unavailable: "Identity verification details aren't shown here yet." }
};
//#endregion
export { e as default };
